'use strict';

const combineNullableStrings = (...arguments_) => arguments_.filter(Boolean).join(' ') || undefined;

const combineClasses = (...arguments_) => combineNullableStrings(...arguments_) ?? '';

exports.combineClasses = combineClasses;
exports.combineNullableStrings = combineNullableStrings;
//# sourceMappingURL=combineClasses-5P8GTQkg.js.map
